import { h } from 'preact'
import { useEffect } from 'preact/hooks'
import PropTypes from 'prop-types'

import Icon from 'components/Icon'
import './index.sass'

const AUTO_DISMISS_MS = 8000

const ALERT_MESSAGES = {
  declined: (name) => `${name} declined the call`,
  noResponse: (name) => `${name} is not responding`,
  notAnswering: (name) => `${name} is not answering`,
}

export default function CallAlertBanner({ alerts, onDismiss }) {
  if (!alerts || alerts.length === 0) return null

  return <div className="CallAlertBanner">
    {alerts.map(alert =>
      <CallAlertItem
        key={alert.id}
        alert={alert}
        onDismiss={() => onDismiss(alert.id)}
      />
    )}
  </div>
}

CallAlertBanner.propTypes = {
  alerts: PropTypes.array.isRequired,
  onDismiss: PropTypes.func.isRequired,
}

function CallAlertItem({ alert, onDismiss }) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, AUTO_DISMISS_MS)
    return () => clearTimeout(timer)
  }, [])

  const getMessage = ALERT_MESSAGES[alert.type]
  const message = getMessage ? getMessage(alert.name) : alert.name

  return <div className="CallAlertBanner-item">
    <Icon type="close" size="sm" className="CallAlertBanner-icon" />
    <span className="CallAlertBanner-message">{message}</span>
    <button
      className="CallAlertBanner-dismiss"
      onClick={onDismiss}
      title="Dismiss"
    >
      ✕
    </button>
  </div>
}
